import React from "react";

const CustomButton = ({
  onPress,
  filledColor = "#000",
  borderColor = "#333",
  textColor = "#fff",
  width = 100,
  title = "Button",
  disabled = false,
}) => {
  return (
    <button
      onClick={onPress}
      disabled={disabled}
      className="py-2 h-[2.8rem] rounded-lg font-normal text-md"
      style={{
        width: `${width}%`,
        backgroundColor: filledColor,
        border: `1px solid ${borderColor}`,
        color: textColor,
        opacity: disabled ? 0.6 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      {title}
    </button>
  );
};

export default CustomButton;
